import { ServerCrashIcon, RefreshCwIcon } from "lucide-react";
import { Button } from "../../ui/button";
import { cn } from "../../../lib/utils";
import React from "react";

interface ErrorBoxProps {
    error: string;
    onRetry?: () => void;
    className?: string;
}

export function ErrorBox({ error, onRetry, className }: ErrorBoxProps) {
    return (
        <div className={cn("flex flex-col gap-2", className)}>
            <div className="rounded-md bg-destructive/10 p-2 text-sm text-destructive animate-in zoom-in-95 slide-in-from-bottom-1">
                <div className="flex flex-row items-center gap-2">
                    <ServerCrashIcon className="h-4 w-4" />
                    <div>
                        <span className="font-medium">Something went wrong: </span>
                        {error}
                    </div>
                </div>
            </div>
            {onRetry && (
                <div className="flex justify-start">
                    <Button onClick={onRetry} className="gap-1.5">
                        <RefreshCwIcon className="h-4 w-4" />
                        Try again
                    </Button>
                </div>
            )}
        </div>
    );
}
